import { Link } from 'react-router-dom';
import { SHOP_CATEGORIES } from '@evi/store-kit';
import styles from './NotFoundPage.module.css';

/** Any path that is not a page, an unknown product and an unknown /why. The
 *  server answers these with a real 404 status (seo/seo.ts). */
export function NotFoundPage() {
  return (
    <div className={styles.page}>
      <h1 className={styles.title}>Page not found</h1>
      <p className={styles.sub}>We could not find that page. It may have moved, or the product may no longer be listed.</p>
      <div className={styles.links}>
        <Link to="/" className="eviBtn eviBtnPrimary">Back to store</Link>
        {SHOP_CATEGORIES.map((c) => (
          <Link key={c.slug} to={`/${c.slug}`} className="eviBtn eviBtnGhost">{c.label}</Link>
        ))}
      </div>
    </div>
  );
}
